import React from "react";

import { Widget, WidgetBody, WidgetHeader } from "../../_widget";

export interface ResetToDefaultSectionProps {
	onClick: VoidFunction;
}

export const ResetToDefaultSection: React.FC<ResetToDefaultSectionProps> = ({ onClick }) => (
	<Widget>
		<WidgetHeader className="uppercase" title="Reset settings" />

		<WidgetBody>
			<button className="button button-secondary w-full uppercase" onClick={onClick} type="button">
				Reset to default
			</button>
		</WidgetBody>
	</Widget>
);
